/**
 * 編集コマンド（索引 Issue #498 の段階 3 → #722）。**文書を変えるのはここだけ**。
 *
 *   apply(doc, command, ctx) → { doc, ok, reason, changed }
 *
 * - 画面は文書を直接いじらない。**1 操作 = 1 コマンド**で、取り消しの単位もこれ
 * - **できないことは例外ではなく `{ ok: false, reason }`**（並びの逆転など）。編集中は「やろうとしてできないこと」が
 *   普通に起きるので、そのたびに落ちては困る
 * - `ctx.timeline` があれば、整列後のアンカーを見て検める
 *
 * 使っているのは 3 つだけ: タイミング調節のタイムライン（`duelTimeline/DuelTimeline.js`）が帯のイベントを動かす・
 * 元に戻す（`anchor/move` / `anchor/clear`）と、ページ（`pages/DuelTiming.js`）がテーマと設定の変化を書く（`doc/setMeta`）。
 * 汎用の編集ソフトのコマンド（オブジェクト・トラック・テンプレート・キーフレーム…）は Issue #722 で消した。
 */
import { readDocument, setMeta } from './document';
import { clearAnchor, moveAnchors, planAnchorMoves } from './anchors';

const err = (reason) => ({ error: reason });

const HANDLERS = {
  /** `{ moves: [{ key, ms }] }` か `{ key, ms }`。整列後の並びを逆転させる移動は断る */
  'anchor/move': (doc, c, ctx) => {
    const moves = c.moves ?? [{ key: c.key, ms: c.ms }];
    const rows = ctx?.timeline?.anchors ?? [];
    if (rows.length) {
      const plan = planAnchorMoves(rows, moves);
      if (!plan.ok) return err(plan.reason);
    }
    return moveAnchors(doc, moves);
  },
  /** 人が動かした時刻を消す（ソースと整列が決める位置へ戻る） */
  'anchor/clear': (doc, c) => clearAnchor(doc, c.key),
  /** 実装固有の入れ物（`meta[key]`。`null` は消す） */
  'doc/setMeta': (doc, c) => setMeta(doc, c.key, c.value),
};

/**
 * コマンドを当てる。**引数の文書は書き換えない**。
 * @returns `{ doc, ok, reason, changed }`
 */
export function apply(doc, command, ctx = {}) {
  const handler = HANDLERS[command?.type];
  if (!handler) return { doc, ok: false, reason: `未知のコマンド: ${command?.type}`, changed: false };
  const d = readDocument(doc);
  let res;
  try {
    res = handler(d, command, ctx);
  } catch (e) {
    return { doc, ok: false, reason: String(e?.message ?? e), changed: false };
  }
  if (res?.error) return { doc, ok: false, reason: res.error, changed: false };
  if (!res || res === d) return { doc, ok: true, reason: null, changed: false };
  return { doc: res, ok: true, reason: null, changed: true };
}
